import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import LogoMark from 'assets/images/logo-mark.svg';
import FooterLogo from 'assets/images/footer-logo.svg';
import SubscribiliLogoDark from 'assets/images/logo-subscribili-dark.png';
import LoginLogo from 'assets/images/login-logo.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Chicago Dental',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'chicagodentalSubscriberToken',
  globalClass: 'group-parent-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  showAddressSuggestion: true,
  headerProps: {
    enable: true,
    buttonProps: {
      enable: true,
      to: '/checkout',
    },
  },
  localeProps: {},
  homeTemplateProps: {
    heroSection: {
      variant: 1,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        variant: 'contained',
        color: 'primary',
        to: '/checkout',
        alwaysRedirect: true,
      },
      secondaryButton: 'Login',
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'secondary',
        to: '/login',
      },
      heroImage: '/images/home-images/home-banner-img.webp',
      verticalAlignImage: 'bottom',
    },
    benefitsSection: {
      variant: 2,
      columns: 2,
      alignTitle: 'center',
      alignCard: 'left',
    },
    subscriptionSection: {
      variant: 2,
      priority: 'top',
      cardVariant: 1,
      // PlanCardVariant1 renders planNameProps.icons[plan_name] before the
      // title; Figma shows the CDS capsule mark there. Keyed by the plan
      // name that the plans API returns for this group.
      planNameProps: {
        showIcon: true,
        icons: { 'CDS Club': LogoMark },
      },
      tabVariant: 1,
      disableGroupSavings: true,
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      planCardProps: {
        buttonProps: {
          customSpace: 11,
          normalVariant: 'contained',
          normalColor: 'primary',
          to: '/find-a-provider',
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      heroImage: '/images/home-images/how-it-works.webp',
      alignTitle: 'left',
    },
    testimonialSection: {
      enable: false,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      alignTitle: 'left',
      primaryButtonProps: {
        color: 'primary',
        variant: 'contained',
      },
    },
  },
  checkoutSection: {
    addIconColor: 'secondary',
  },
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    iconProps: {
      url: '/images/map-loc-icon.svg',
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 1,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: true,
  },
  savingsSummary: {
    // Figma hero has both a primary and a secondary button; the MFE only
    // enables the secondary by default.
    heroProps: {
      primaryButtonProps: {
        enable: true,
        variant: 'contained',
        color: 'primary',
      },
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'secondary',
      },
    },
    // Figma's savings page ends the table and goes straight to the contact
    // section; no footer bar.
    enableFooterbar: false,
    showCategoryHeaders: true,
    showPlanDiscHeader: true,
    contactSection: 'contactDetails',
    buttonProps: {
      variant: "outlined",
      color: "secondary",
      size: "large",
    },
  },
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
    // The MFE's bundled lockup is a white knockout for dark footers; this
    // footer is Alabaster, so pass the dark variant.
    subscribiliLogo: SubscribiliLogoDark,
  },
  loginPage: {
    bannerImage: './images/login.webp',
    logo: LoginLogo,
  },
  theme: Theme,
};

export default config;
